import { render, staticRenderFns } from "./rma_history_table.vue?vue&type=template&id=5182723e&"
import script from "./rma_history_table.vue?vue&type=script&lang=js&"
export * from "./rma_history_table.vue?vue&type=script&lang=js&"
import style0 from "./rma_history_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports